import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobs'
import Component from 'components/Jobs/Future'

export default createListViewContainer({ actions, selectors: selectors.jobs })(Component)
